const prefix = 'SCHOOL_FUNC_';
export const OPEN_SCHOOL_MODAL = `${prefix}OPEN_SCHOOL_MODAL`;
export const CLOSE_SCHOOL_MODAL = `${prefix}CLOSE_SCHOOL_MODAL`;

export const CHANGE_SCHOOL = `${prefix}CHANGE_SCHOOL`;

export const GET_SCHOOL = `${prefix}GET_SCHOOL`;
export const GET_SCHOOL_SUCCESS = `${prefix}GET_SCHOOL_SUCCESS`;

export const SET_LIST_SCHOOL = `${prefix}SET_LIST_SCHOOL`;

export const RESET = `${prefix}RESET`;
